






















































import v8n from 'v8n';
import { Component, Vue, Prop, Watch } from 'vue-property-decorator';
import { Processing, Legislation } from '@/api';

import snackModule from '@/store/Snack';

import LegislationSelect from '@/components/common/LegislationSelect.vue';

@Component({
  components: {
    LegislationSelect,
  },
})
export default class ProcessingInformation extends Vue {
  @Prop({ required: true }) readonly item: Processing;

  processing = new Processing(); // tmp value

  processingOriginal = new Processing();

  valid = false;

  isDirty = false;

  loading = false;

  requiredString = [
    (v: string) =>
      v8n()
        .string()
        .not.empty()
        .test(v) || this.$t('processings.validation.requiredPublish'),
  ];

  requiredObject = [
    (v: Legislation) => {
      if (!v) {
        return this.$t('common.validation.generalRequired');
      }

      return (
        v8n()
          .string()
          .not.empty()
          .test(v.id) || this.$t('common.validation.generalRequired')
      );
    },
  ];

  get editMode() {
    return this.$route.name === 'processing-profiles-edit';
  }

  get validation() {
    let validation;
    if (this.isDirty) {
      validation = 'unsaved';
    } else if (!this.valid) {
      validation = 'invalid';
    } else {
      validation = 'complete';
    }
    return validation;
  }

  get formFields() {
    return [
      this.processing.legislation ? this.processing.legislation.id : null,
      this.processing.name,
      this.processing.referenceCode,
    ];
  }

  cancel() {
    this.processing = this.processingOriginal.dup();
  }

  async save() {
    try {
      this.loading = true;
      await this.processing.save({
        with: ['legislation.id'],
      });
      this.isDirty = false;
      this.$emit('updated', this.processing);
      snackModule.setSuccess(this.$t('processings.alerts.updated') as string);
    } catch (e) {
      snackModule.setError({
        text: this.$t('processings.alerts.notUpdated') as string,
        errors: e.response.errors,
      });
    } finally {
      this.loading = false;
    }
  }

  async saveContinue() {
    await this.save();
    this.$emit('continue', 1);
  }

  @Watch('item', { immediate: true })
  async itemChanged() {
    this.processing = this.item.dup();
    this.processingOriginal = this.item.dup();
  }

  @Watch('validation', { immediate: true })
  validChanged() {
    this.$emit('validation', this.validation);
  }

  @Watch('formFields')
  dirtyChanged() {
    this.isDirty = this.processing.isDirty('legislation');
  }
}
